import axios from "axios";
import { userServiceUrl } from "../../Config/config";

export const COMPLETESESSION_REQUEST = "COMPLETESESSION_REQUEST";
export const COMPLETESESSION_SUCCESS = "COMPLETESESSION_SUCCESS";
export const COMPLETESESSION_FAILURE = "COMPLETESESSION_FAILURE";

const createAction = (type, payload = null) => ({ type, payload });

export const Initiatecompletesession = (id) => async (dispatch) => {
  dispatch(createAction(COMPLETESESSION_REQUEST));
  try {
    const token = localStorage.getItem("token");
    if (!token) {
      const errorMessage = "No token found";
      dispatch(createAction(COMPLETESESSION_FAILURE, errorMessage));
      throw new Error(errorMessage);
    }

    const response = await axios.get(
      `${userServiceUrl}/provider/initiate-complete-session/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );

  
    if (response?.data) {
      dispatch(createAction(COMPLETESESSION_SUCCESS, response.data));
    } else {
      const errorMessage = "Invalid response structure";
      dispatch(createAction(COMPLETESESSION_FAILURE, errorMessage));
      throw new Error(errorMessage);
    }

    return response.data; 
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || "An unknown error occurred";
    dispatch(createAction(COMPLETESESSION_FAILURE, errorMessage));
    console.error(error);
    throw new Error(errorMessage);
  }
};
